<template>
    <div>
        <b-form id="form" class="form" action="#" method="post" @submit="onSubmit">
            <b-container id="pageRegisteration" class="page" fluid>
                <b-row>
                    <b-col sm="12">
                        <ul id="tabs" class="">
                            <li >
                                <a href="#" id="tabsFlight" data-tabIndex="0" @click="tabsFormClick" class="tab active">Flight</a>
                            </li>
                            <li>
                                <a href="#" id="tabsParticulars" data-tabIndex="1" @click="tabsFormClick" disabled class="tab disabled">Particulars</a>
                            </li>
                            <li>
                                <a href="#" id="tabsSummary" data-tabIndex="2" @click="tabsFormClick" disabled class="tab disabled">Summary</a>
                            </li>
                        </ul>
                    </b-col>
                </b-row>
                <b-row>
                    <FormFlight class="tab-content-container" :formData="formData.flight" v-if="this.tabIndex==0"></FormFlight>
                    <FormParticulars class="tab-content-container" :formData="formData.particulars" :dateFormat="dateFormat" :dateFormatMoment="dateFormatMoment" v-if="this.tabIndex==1"></FormParticulars>
                    <Summary class="tab-content-container" :formData="formData" :dateFormat="dateFormat" :dateFormatMoment="dateFormatMoment" v-if="this.tabIndex==2"></Summary>
                </b-row>
                <b-row>
                    <footer class="text-center">
                        <a class="btn btn-negative btnPrevious" v-if="this.tabIndex != 0" @click="tabsFormClick">Back</a>
                        <a class="btn btn-primary btnNext" v-if="this.tabIndex != 2" @click="tabsFormClick">Next</a>
                        <button id="submit" class="btn btn-danger" v-if="this.tabIndex == 2">Submit</button>
                    </footer>
                </b-row>
            </b-container><!-- page ends -->
        </b-form>
    </div>
</template>

<script>
import FormFlight from './FormFlight';
import FormParticulars from './FormParticulars';
import Summary from './Summary';
import validator from 'validator';
import moment from 'moment';

export default {
    name: 'Registration',
    data() {
        return {
            tabIndex: 0,
            dateFormat: 'dd/MM/yyyy',
            dateFormatMoment: 'DD/MM/YYYY',
            date12YearsDate: new Date(),
            passportExpiryDate: new Date()
        }
    },
    props: ['formData', 'showModal' ],
    components: {
        FormFlight,
        FormParticulars,
        Summary
    },
    computed: {
        date12Years() {
            return moment(this.date12YearsDate.setFullYear(this.date12YearsDate.getFullYear() - 12)).format(this.dateFormatMoment);
        },
        passportExpiry() {
            return moment(this.passportExpiryDate.setMonth(this.passportExpiryDate.getMonth() + 6)).format(this.dateFormatMoment);
        }
    },
    methods: {
        // tabsFormClick2(e) {
        //     e.preventDefault();
        //     const tabs = document.querySelectorAll('#tabs li');
        //     const nextIndex = e.target.dataset.tabindex;
            
        //     let validateFormResult = this.validateForm(this.tabIndex);
        //     if (validateFormResult != '') {
        //         window.console.log('error', validateFormResult);
        //         this.modalTitle = 'Warning';
                
        //         return;
        //     }
        //     this.tabIndex = nextIndex;
        //     tabs.forEach((tab, index)=> {
        //         if (index == nextIndex) {
        //             tab.querySelector('a').classList.add('active');
        //             tab.querySelector('a').classList.remove('disabled');
        //         }
        //         else {
        //             tab.querySelector('a').classList.remove('active');
        //         }
        //     });
        // },
        tabsFormClick(e) { 
            e.preventDefault();
            const direction = e.target.text;
            const tabs = document.querySelectorAll('#tabs li');
            let validateFormResult = this.validateForm(this.tabIndex);
            if (validateFormResult != '') {
                window.console.log('error', validateFormResult);
                this.$emit('showModal', 
                    'Error',
                    validateFormResult
                );
                
                return;
            }
            
            if (e.target.dataset.tabindex) {
                this.tabIndex = e.target.dataset.tabindex;
            }
            else {
                if (direction.toLowerCase() == 'next') {
                    this.tabIndex++;
                }
                else {
                    this.tabIndex--;
                }
            }
   
            tabs.forEach((tab, index)=> {
                if (index == this.tabIndex) {
                    tab.querySelector('a').classList.add('active');
                    tab.querySelector('a').classList.remove('disabled');
                }
                else {
                    tab.querySelector('a').classList.remove('active');
                }
            });
            
            
        },
        validateForm(tab) {
            let error = '';
            // const date12Years = new Date();
            // date12Years.setFullYear(date12Years.getFullYear() - 12);
            // const passportExpiryDate = new Date();
            // passportExpiryDate.setMonth(passportExpiryDate.getMonth() + 6);
            switch (tab) {
                case 0: 
                if(document.querySelector('#countryOfDeparture').value == '') {
                    error += 'Please select country of departure. <br>';
                }
                if(document.querySelector('#countryOfDeparture').value == 'Others' && document.querySelector('#countryOfDepartureOthers').value == '') {
                    error += 'Please enter other country of departure. <br>';
                }
                if(document.querySelector('#flight').value == '') {
                    error += 'Please select preferred flight. <br>';
                }
                
                break;
                case 1: 
                if(document.querySelector('#lastName').value == '') {
                    error += 'Please enter family name. <br>';
                }
                if(document.querySelector('#firstName').value == '') {
                    error += 'Please enter other give name. <br>';
                }
                if(document.querySelector('#jobTitle').value == '') {
                    error += 'Please enter job title. <br>';
                }
                if(document.querySelector('#department').value == '') {
                    error += 'Please select department. <br>';
                }
                
                if(document.querySelector('#dateOfBirth').value == '') {
                    error += 'Please enter date of birth. <br>';
                }
                
                if(validator.isAfter(moment(this.formData.particulars.dateOfBirth).format(this.dateFormatMoment), this.date12Years)) {
                    error += 'Participant must be above 12 years old. Please get an adult to register for the flight.<br>';
                }
                if(document.querySelector('#nationality').value == '') {
                    error += 'Please enter nationality. <br>';
                }
                if(document.querySelector('#passportNo').value == '') {
                    error += 'Please enter passport number. <br>';
                }

                if(document.querySelector('#passportExpiry').value == '') {
                    error += 'Please enter date of passport expiry. <br>';
                }
                // window.console.log(this.passportExpiry);
                // window.console.log(validator.isAfter(moment(this.formData.particulars.passportExpiry).format(this.dateFormatMoment), this.passportExpiry));
                if(validator.isBefore(moment(this.formData.particulars.passportExpiry).format(this.dateFormatMoment), this.passportExpiry)) {
                    error += 'Passport expiry date must be more than 6 months before expiry.<br>';
                }

                if(document.querySelector('#email').value == '') {
                    error += 'Please enter email. <br>';
                }
                if (document.querySelector('#email').value != '' && !validator.isEmail(document.querySelector('#email').value)) {
                    error += 'Please enter correct email format. <br>';
                }
                if(document.querySelector('#emergencyName').value == '') {
                    error += 'Please enter emergency contact\'s name. <br>';
                }
                if(document.querySelector('#emergencyRelationship').value == '') {
                    error += 'Please enter emergency contact\'s relationship. <br>';
                }
                if(document.querySelector('#emergencyContact').value == '') {
                    error += 'Please enter emergency contact\'s contact. <br>';
                }

                
                break;
                default:
                break;
            }
            return error;
        },
        onSubmit(e) {
            e.preventDefault();
            this.$router.push('/status');
        }
    }
}
</script>

<style lang="less" scoped>


// .tab-content-container {
//     height: calc(100vh - 300px);
// }

form {
	fieldset {
        .boxContainer;	
        
	}

	input[type=checkbox], input[type=radio] {
		margin: 2px 5px 0 0;
	}

	textarea {
		height: 100px;
	}
	.required {
		color: @red;
	}
	label .required {
		color: @red;
		font-size: 0.750em;
	}
	
}

</style>